import { apiDaInscricao } from "../../../servicos/axios";

export interface Projeto {
  id: number;
  nome: string;
  idPrograma: number;
  descricao: string;
  dataInicio: string;
  dataFim: string;
  textoDeCiencia: string;
}

export const buscarProjetoPorId = async (
  idProjeto: number
): Promise<Projeto> => {
  const response = await apiDaInscricao().get(`/projeto/${idProjeto}/projeto`);
  return response.data;
};
